import React from 'react';

export const useEffectOnMount = (callback: any) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(callback, []);
};
